import {
  ImageResource1861inqz1dzjl as ImageResource,
  FontDirect3ifj3qs5hfije as FontDirect,
  Font1uq8v2r7qm3xe as Font,
} from '../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ResourcesClass;
function Resources() {
  if (ResourcesClass === VOID) {
    class $ {
      constructor() {
        Resources_instance = this;
        this.logoHorizontal_1 = ImageResource().new_com_lightningkite_kiteui_models_ImageResource_isu8ml_k$('common/logo-horizontal.png');
        this.logoSquare_1 = ImageResource().new_com_lightningkite_kiteui_models_ImageResource_isu8ml_k$('common/logo-square.png');
        this.publicsans_1 = new (Font())('publicsans', VOID, VOID, new (FontDirect())(mapOf([to(300, 'common/publicsans/light.ttf'), to(400, 'common/publicsans/regular.ttf'), to(500, 'common/publicsans/medium.ttf'), to(700, 'common/publicsans/bold.ttf')]), mapOf([to(700, 'common/publicsans/semi-bold-italic.ttf'), to(400, 'common/publicsans/italic.ttf'), to(500, 'common/publicsans/medium-italic.ttf'), to(300, 'common/publicsans/light-italic.ttf')])));
        this.tinyLkLogo_1 = ImageResource().new_com_lightningkite_kiteui_models_ImageResource_isu8ml_k$('common/tiny-lk-logo.png');
      }
    }
    initMetadataForObject($, 'Resources');
    ResourcesClass = $;
  }
  return ResourcesClass;
}
var Resources_instance;
function Resources_getInstance() {
  if (Resources_instance === VOID)
    new (Resources())();
  return Resources_instance;
}
//region block: exports
export {
  Resources_getInstance as Resources_getInstance22dnzrm1gxkf3,
};
//endregion

//# sourceMappingURL=Resources.js.mjs.map
